import React from 'react';

import Button from 'brandComponents/Button';
import Icon from 'brandComponents/Icon';

import {IMuteButtonProps} from './IMuteButton';

const MuteButton = ({setIsMuted, isMuted, icons} : IMuteButtonProps) => {
	return (
		<Button
			classNames="mute-button"
			onClick={(e) => {
				e.preventDefault();
				setIsMuted(!isMuted);
			}}
		>
			{isMuted
				? <Icon
					name={icons.muted}
					height={icons.height}
					width={icons.width}
				/>
				: <Icon
					name={icons.unmuted}
					height={icons.height}
					width={icons.width}
				/>
			}
		</Button>
	);
};

export default MuteButton;
